<!-- src/shared/components/logos/NotoryVaultLogoIcon.vue -->
<!--
  Notory Vault - Marken-Logo (Copper Constellation, notory.io-Branddesign).
  Eigenes Asset unseres Rebrands. Schloss (Vault) zentral + verschluesselte
  Verbindung von oben-rechts/unten-links im Konstellations-Stil.
-->
<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      size?: number;
      ariaLabel?: string;
      title?: string;
    }>(),
    { size: 64 }
  );
</script>

<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    :aria-label="props.ariaLabel">
    <title v-if="props.title">{{ props.title }}</title>
    <defs>
      <linearGradient id="nv-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#24262C" />
        <stop offset="1" stop-color="#15161A" />
      </linearGradient>
    </defs>
    <rect width="32" height="32" rx="7" fill="url(#nv-bg)" />
    <path d="M7 25 L10 22" stroke="#C6703D" stroke-width="1.3" stroke-linecap="round" />
    <path d="M25 7 L22 10" stroke="#C6703D" stroke-width="1.3" stroke-linecap="round" />
    <circle cx="7" cy="25" r="1.6" fill="#E3A06A" />
    <circle cx="25" cy="7" r="1.6" fill="#C6703D" />
    <circle cx="16" cy="14" r="4.4" fill="none" stroke="#C6703D" stroke-width="1.8" />
    <path
      d="M13.3 18.5 L12.2 24 h7.6 L18.7 18.5"
      fill="none"
      stroke="#C6703D"
      stroke-width="1.8"
      stroke-linejoin="round"
      stroke-linecap="round" />
    <circle cx="16" cy="14" r="1.4" fill="#E3A06A" />
  </svg>
</template>
